import React from 'react';

import { useLoaderData } from 'react-router-dom';

import AdvisedClientAgreementSignature, {
  AdvisedClientAgreementSignatureProps,
} from '../AdvisedClientAgreementSignature';

const AdvisedClientAgreementSignatureApp: React.FC = () => {
  const loaderData = useLoaderData<AdvisedClientAgreementSignatureProps>();

  return <AdvisedClientAgreementSignature {...loaderData} />;
};
export default AdvisedClientAgreementSignatureApp;
